module.exports = __webpack_public_path__ + "media/images/6-fd4d348d09e33331a511a222c11512b0.jpg";